import { render, staticRenderFns } from "./addMessageTopic.vue?vue&type=template&id=3173bd1d&"
import script from "./addMessageTopic.vue?vue&type=script&lang=js&"
export * from "./addMessageTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports